export default __webpack_public_path__ + "static/dont-decorative-only-6ebdf488c7f4dcd5969119771c83b29e5292f327c675b76f51f3048492fd14c0.png";